import { Link } from "react-router-dom";

interface WorkspaceInfoCardProps {
  workspaceId: number;
  workspaceTitle: string;
  workspaceImageUrl: string | null;
  bookingId: number;
}

export default function WorkspaceInfoCard({
  workspaceId,
  workspaceTitle,
  workspaceImageUrl,
}: WorkspaceInfoCardProps) {
  return (
    <div className="p-4 bg-gray-50 border-b border-gray-200">
      <Link
        to={`/workspace/${workspaceId}`}
        className="flex items-center gap-4 group"
      >
        <img
          src={workspaceImageUrl || "/placeholder-workspace.jpg"}
          alt={workspaceTitle}
          className="w-16 h-16 rounded-lg object-cover"
          onError={(e) => {
            (e.target as HTMLImageElement).src = "/placeholder-workspace.jpg";
          }}
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-gray-900 truncate group-hover:text-[var(--secondary)] transition-colors">
              {workspaceTitle}
            </h3>
            <svg
              className="w-4 h-4 text-gray-400 group-hover:text-[var(--secondary)] transition-colors flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
          </div>
          <p className="text-sm text-gray-500">View workspace details</p>
        </div>
      </Link>
    </div>
  );
}
